"use client";

import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useRouter } from "next/navigation";
import { fevicolInhomzRootRoute } from "../../../_constants/tempRootRoute";
import MaxWidth from "@/app/(main_app)/_components/MaxWidth";
import { inhomzEvents } from "../../../_lib/events";
import { useInhomzTrack } from "../../../_hooks/useInhomzTrack";

export default function CategoryHeader({ title, category }) {
  const router = useRouter();
  const track = useInhomzTrack();

  const handleBack = () => {
    track(inhomzEvents.designCategory.BACK_CLICKED, { category });
    router.push(`${fevicolInhomzRootRoute}/design-ideas`);
  };

  return (
    <MaxWidth className="sticky top-0 z-10" padding="p-0">
      <header className="flex items-center gap-2 bg-[--colorSurfaceSurface] py-2  md:py-3">
          <IconButton onClick={handleBack} aria-label="Go back" sx={{ color: "var(--textPrimaryPrimary)" }}>
            <ArrowBackIcon />
          </IconButton>
          <h1 className="m3-title-medium text-[--textPrimaryPrimary] md:m3-title-large">{title}</h1>
      </header>
    </MaxWidth>
  );
}
